/** Reforma tributária (IBS/CBS): ficha por cliente, ações de adequação e tarefas. */
import { createFileRoute } from '@tanstack/react-router';
import { Reforma } from '../telas/reforma/reforma';

export const Route = createFileRoute('/_app/reforma')({ component: Reforma });
